import script from "./LineChatMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./LineChatMessages.vue?vue&type=script&setup=true&lang=js"

import "./LineChatMessages.vue?vue&type=style&index=0&id=ce8bb7a0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce8bb7a0"]])

export default __exports__